import React from 'react';
import axios from 'axios';
import moment from 'moment';

export default class Callins extends React.Component{
    constructor(p){
        super(p);
        this.state = {
            A: [],
            PCOD_TO_PARTNO: {},
            X: {},
            LoopDateArray: [],
            maxDayInterval: 8,
            searchDate: moment('2021-11-23'),
            last_updated: moment('1992-01-01'),
            SUM: {},
            FG: {},
            WIP: {},
            FGREM: {},
            SB_STOCK: {}
        }
    }
    

    async getSheetboardForPcode(pcode){
        let res = await axios.post('http://192.168.9.111:8999/scripts/qry.php', {
            qry: `SELECT spo.grade,spo.wdat,spo.ldat,spo.flute FROM spo_checkout SC
                INNER JOIN spo ON spo.spo_prefix = SC.spoprefix AND spo.spo_id = SC.sponumber
                LEFT JOIN supplyinterface ON spo.supplyIDs = supplyinterface.id
                WHERE supplyinterface.pcode = '${pcode}'
                ORDER BY SC.id DESC
                LIMIT 1`
        });
        let lastuse = res.data[0];
        if(!lastuse) return {
            stock: 0
        };
        let res2 = await axios.post('http://192.168.9.111:8999/scripts/qry.php', {
            qry: `SELECT spo.grade,spo.flute,spo.wdat,spo.ldat,SUM(aggreg) as stock FROM spo 
            INNER JOIN spo_palette_ag SPA ON SPA.spo_prefix = spo.spo_prefix AND SPA.spo_id = spo.spo_id
            WHERE grade = '${lastuse.grade}' AND wdat = ${lastuse.wdat} AND ldat = ${lastuse.ldat} and flute = '${lastuse.flute}' `
        });
        return res2.data[0];
    }

    async componentDidMount(){
        
        let LoopDateArray = []
        for (var i = 0; i < Number(this.state.maxDayInterval); i++) {
            LoopDateArray.push(i);
        }
        let SUM = {};
        let SUM_PREV = {};

        let last_updated = null;

        let FG = {};
        let WIP = {};

        let res0 = await axios.post('http://192.168.9.111:8999/scripts/qry.php', {
            qry: `SELECT SUM(WIP+issue_WIP) as test_wip, pcode FROM rongb_job GROUP BY pcode`
        });
        res0.data.forEach((row)=>{
            if(row.test_wip < 0) row.test_wip = 0;

            FG[row.pcode] = 0;
            WIP[row.pcode] = row.test_wip;
        });
        
        let res1 = await axios.post('http://192.168.9.111:8999/scripts/qry.php', {
            qry: `SELECT COALESCE(MAX(batch_id), 0) as maxb FROM mrp_delta`
        });
        let num = parseInt(res1.data[0]['maxb']);
        let lastnum = num - 1;

        let sumQry = `SELECT CONCAT(partno, '-', mrp_delta.ddmmyy) as ukey, partno, mrp_delta.ddmmyy, mrp_delta.pcode, \`desc\`, SUM(qty) as sqty, PVX.sqty as last_sqty, MAX(created) as last_created
                    FROM mrp_delta LEFT JOIN ( SELECT CONCAT(partno, '-', ddmmyy) as ukey, SUM(qty) as sqty, pcode, ddmmyy FROM mrp_delta WHERE batch_id = ${lastnum} GROUP BY partno, ddmmyy, pcode) PVX 
                    ON mrp_delta.ddmmyy = PVX.ddmmyy AND PVX.pcode = mrp_delta.pcode WHERE mrp_delta.batch_id = ${num} GROUP BY mrp_delta.partno, mrp_delta.ddmmyy, mrp_delta.pcode`;
        let res = await axios.post('http://192.168.9.111:8999/scripts/qry.php', {
            qry: sumQry
        });
        let A = res.data.sort((a, b) => {
            return moment(a.ddmmyy, "DD/MM/YY").valueOf() - moment(b.ddmmyy, "DD/MM/YY").valueOf()
        });
        // debugger;
        let X = {};
        let PCOD_TO_PARTNO = {};

        A.forEach((a)=>{
            if(!X[a.pcode]){
                X[a.pcode] = [];
            }
            if(!last_updated){
                last_updated = moment(a.last_created);
            }

            if(moment(a.last_updated) > last_updated){
                last_updated = moment(a.last_created);
            }

            a._ddmmyy = moment(a.ddmmyy, 'DD/MM/YY');

            if(!SUM[a.pcode + " " + a.ddmmyy]){
                SUM[a.pcode + " " + a.ddmmyy] = 0;
            }
            if(!SUM_PREV[a.pcode + " " + a.ddmmyy]){
                SUM_PREV[a.pcode + " " + a.ddmmyy] = 0;
            }

            SUM[a.pcode + " " + a.ddmmyy] += Number(a.sqty);
            SUM_PREV[a.pcode + " " + a.ddmmyy] += Number(a.last_sqty);

            if(!SUM[a.ddmmyy]){
                SUM[a.ddmmyy] = 0;
            }
            if(!SUM_PREV[a.ddmmyy]){
                SUM_PREV[a.ddmmyy] = 0;
            }

            SUM[a.ddmmyy] += Number(a.sqty);
            SUM_PREV[a.ddmmyy] += Number(a.last_sqty);

            if(!SUM[a.pcode]){
                SUM[a.pcode] = 0;
            }

            SUM[a.pcode] += Number(a.sqty);

            X[a.pcode].push(a);
            PCOD_TO_PARTNO[a.pcode] = a.partno;
        });
        this.setState(
            {
                WIP,
                FG,
                SUM,
                SUM_PREV,
                last_updated,
                PCOD_TO_PARTNO,
                X, 
                A,
                LoopDateArray
            }
        );

        let PCODES = Object.keys(X);
        let FGREM = {};
        PCODES.forEach((pcode)=>{
            
            this.getSheetboardForPcode(pcode).then((res)=>{
                let SB_STOCK =  {...this.state.SB_STOCK};
                SB_STOCK[pcode] = Number(res.stock);
                this.setState({
                    SB_STOCK
                })
            })

            LoopDateArray.map((m) => {
                let loopDate = moment(this.state.searchDate).utc(false).set('hour', 8).set('minute', 0).set('second', 0).add(m, 'weeks');
                let sumForDate = SUM[pcode + " " +  loopDate.format("DD/MM/YY")] 
                if(!FGREM[pcode]){
                    FGREM[pcode] = [];
                }
                let nv = (FG[pcode] || 0) - (sumForDate || 0);
                FGREM[pcode].push(nv);
                FG[pcode] = nv;
            });
        });

        this.setState({
            FGREM
        })
    }
  
    render(){
        let PCODES = Object.keys(this.state.X);
        let last_updated = this.state.last_updated.format("DD/MM/YY HH:mm");

        return <div className="container-fluid">

            <div className="row py-3">
                <div className="col-8">
                    <h4>Delta Electronics</h4> นำเข้าอัพเดทล่าสุด {last_updated}
                   
                </div>
                <div className="col-1">
                  ระยะข้อมูล
                  <input autoComplete={false} type="date" onChange={(e)=>{
                      this.setState({
                          searchDate: moment(e.target.value)
                      })
                  }} value={this.state.searchDate.format("YYYY-MM-DD")}></input> <i className="fa fa-plus"></i> 
                  <input type="number" style={{width: 50}} className="small" value={this.state.maxDayInterval} onChange={(e)=>{
                      let LoopDateArray = []
                      for (var i = 0; i < Number(e.target.value); i++) {
                          LoopDateArray.push(i);
                      }
                      this.setState({
                          maxDayInterval: Number(e.target.value),
                          LoopDateArray
                      })
                  }} size="3"></input> Week
                </div>
                
                <div className="col">
                    <a href="/import/callin" className="float-right btn btn-primary btn-sm">
                        <i className="fa fa-plus"></i> Import Excel 
                    </a>
                </div>

            </div>

            <table className="table table-sm">
                <thead>
                    <tr className="text-sm small">
                        <th style={{width: 200}}>PCODE</th>
                        {this.state.LoopDateArray.map((m) => {
                            let loopDate = moment(this.state.searchDate).utc(false).set('hour', 8).set('minute', 0).set('second', 0).add(m, 'weeks');
                            return <th style={{width: 150}}>
                                <span className='text-muted'>Week of</span> {loopDate.format("DD/MM (dd)")}
                            </th>
                        })}
                    </tr>
                </thead>
                <tbody>
                   { PCODES.map((pcode,i)=>{
                       return (<tr key={pcode}>
                            <td><strong>{pcode}</strong><br/><small>{this.state.PCOD_TO_PARTNO[pcode]}</small>
                            <br/>
                               <span className='text-dark'>
                               <span className='badge badge-light'>μ</span> 0<small></small>
                               <br/>
                               <span className='badge badge-light'>σ</span> 0%
                               {/* <br/>
                               <span className='badge badge-secondary'>&Sigma;</span> {this.state.SUM[pcode]} */}
                               </span>
                            </td>
                            {this.state.LoopDateArray.map((m, j) => {
                                let loopDate = moment(this.state.searchDate).utc(false).set('hour', 8).set('minute', 0).set('second', 0).add(m, 'weeks');
                                
                                let ArrayForRow = this.state.X[pcode];
                                let ArrayForCell = ArrayForRow.filter((x)=>{
                                    let targetLoopDate = x._ddmmyy.format("DD/MM/YY");
                                    return targetLoopDate === loopDate.format("DD/MM/YY")
                                });
                                let rckey = pcode + " " +  loopDate.format("DD/MM/YY");

                                return <td>
                                    <table className="table table-sm">
                                        <tbody>
                                        {/* {ArrayForCell.sort((x,y)=>x.calltime.localeCompare(y.calltime)).map((c,i)=>{
                                            return <tr className="small">
                                                <td><strong>{c.calltime}</strong></td>
                                                <td>{c.sqty}</td>
                                            </tr>
                                        })} */}
                                        {/* <tr>
                                            <td><small>
                                                FG {Intl.NumberFormat('en-US').format((this.state.FGREM[pcode]||[])[j]) || 0}
                                                </small></td>
                                        </tr> */}
                                        <tr hidden={ArrayForCell.length===0}>
                                            {/* <td>&Sigma;</td> */}
                                            <td className={
                                                (this.state.SUM_PREV[rckey] > this.state.SUM[rckey] ? 'bg-danger' : 
                                                    ( this.state.SUM_PREV[rckey] < this.state.SUM[rckey] ? 'bg-primary' : 'bg-dark' )
                                                ) + ' text-light'
                                            }>
                                                <strong>
                                                    
                                                    <small hidden={this.state.SUM_PREV[rckey] == this.state.SUM[rckey]}> 
                                                    {Intl.NumberFormat('en-US').format((
                                                        this.state.SUM_PREV[rckey]
                                                    ) || 0)} &rarr; &nbsp;
                                                    </small>

                                                    {Intl.NumberFormat('en-US').format(this.state.SUM[rckey] || 0)} 
                                                    
                                                </strong>
                                                
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                {/* <small>W {Intl.NumberFormat('en-US').format(this.state.FG[pcode])}</small>
                                                <br/> */}
                                                <small
                                                    style={{
                                                        "color" : (  (this.state.FGREM[pcode]||[])[j] < 0 ? "red" : "black" )
                                                    }}
                                                >FG {Intl.NumberFormat('en-US').format((this.state.FGREM[pcode]||[])[j]) || 0}</small>
                                                <br/>
                                                <small>
                                                    WIP {Intl.NumberFormat('en-US').format((this.state.WIP[pcode]))} 
                                                </small>
                                                <br/>
                                                <small>
                                                    SB {Intl.NumberFormat('en-US').format(this.state.SB_STOCK[pcode] || 0)}
                                                </small>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table> 
                                </td>
                            })}
                        </tr>)
                   }) }
                </tbody>
            </table>
        </div>
    }
}